import React from 'react';

/**
 * A reusable dialog modal component that supports dynamic content
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether the dialog is visible
 * @param {string} props.title - Dialog title 
 * @param {React.ReactNode} props.children - Dialog content
 * @param {Function} props.onClose - Function to call when closing the dialog
 * @param {string} props.closeButtonText - Text for the close button (default: "X")
 * @param {boolean} props.showOverlay - Whether to show the background overlay
 */

const closeButtonTextDefault = "X";

const DialogModal = ({ 
  show, 
  title, 
  children, 
  onClose, 
  closeButtonText = closeButtonTextDefault,
  showOverlay = true,
  dialogClassName = ''
}) => {
  if (!show) return null;

  return (
    <div className={`finish-dialog-container ${dialogClassName}`}>
      {showOverlay && <div className="finish-dialog-overlay" onClick={onClose}></div>}
      <div className="finish-dialog-modal">
        <div className="finish-dialog">
          {title && <h2>{title}</h2>}
          {title && <div className="finish-divider"></div>}
          
          {children}
        </div>

        <div className="d-button d-mid-button cta-button" onClick={onClose}>
          <span>{closeButtonText}</span>
        </div>
      </div>
    </div>
  );
};

export default DialogModal; 